export const UNIT_AMENITIES = {
  AC: "ac",
  CENTRAL_HEAT: "centralHeat",
  ELECTRICAL_HEATING: "electricalHeating",
  RADIATOR_HEATING: "radiatorHeating",
  FIREPLACE: "fireplace",
  CARPET: "carpet",
  CEILING_FAN: "ceilingFan",
  HARDWOOD_FLOOR: "hardwoodFloor",
  WALKIN_CLOSET: "walkInCloset",
  HIGH_CEILINGS: "highCeilings",
  BATHROOM_FAN: "bathroomFan",
  BALCONY: "balcony"
}

export const Unit_Amenities = [
  { name: "AC", value: UNIT_AMENITIES.AC },
  { name: "Central Heat", value: UNIT_AMENITIES.CENTRAL_HEAT },
  { name: "Electrical Heating", value: UNIT_AMENITIES.ELECTRICAL_HEATING },
  { name: "Radiator Heating", value: UNIT_AMENITIES.RADIATOR_HEATING },
  { name: "Fireplace", value: UNIT_AMENITIES.FIREPLACE },
  { name: "Carpet", value: UNIT_AMENITIES.CARPET },
  { name: "Ceiling Fan", value: UNIT_AMENITIES.CEILING_FAN },
  { name: "Hardwood Floor", value: UNIT_AMENITIES.HARDWOOD_FLOOR },
  { name: "Walk-In Closet", value: UNIT_AMENITIES.WALKIN_CLOSET },
  { name: "High Ceilings", value: UNIT_AMENITIES.HIGH_CEILINGS },
  { name: "Bathroom Fan", value: UNIT_AMENITIES.BATHROOM_FAN },
  { name: "Balcony", value: UNIT_AMENITIES.BALCONY }
]
